import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "Department";

export const getDepartmentsUrl = (facultyId) =>
	`${baseUrl}${facultyId ? `?facultyId=${facultyId}` : ""}`;
export const getDepartmentOptionUrl = ({ departmentId }) =>
	`${baseUrl}/${departmentId}/departmentoptions`;
export const getApplicationDepartmentsUrl = (applicationTypeId, facultyId) =>
	`${baseUrl}/${applicationTypeId}${
		facultyId ? `/${facultyId}` : ""
	}/application-departments`;

export const getAllHODsUrl = (filter) =>
	`${baseUrl}/all-hods?${generateUrlParams(filter)}`;
export const assignHODToDepartmentUrl = () =>
	`${baseUrl}/assignhodtodepartment`;
export const getJupebOptionsUrl = () => `${baseUrl}/all-jupebOptions`;
export const getJupebOptionsSubjectsUrl = (id) =>
	`${baseUrl}/all-jupebOptionsSubject?jupebOptionsId=${id}`;
export const getAllDepartmentActiveSessionsUrl = (filter) =>
	`${baseUrl}/get-all-depts-active-sessions?${generateUrlParams(filter)}`;
export const setDepartmentActiveSessionUrl = () =>
	`${baseUrl}/set-active-session`;
export const rollbackDepartmentActiveSessionUrl = () =>
	`${baseUrl}/rollback-active-session`;

export const getLevelCourseAdvisersUrl = (filter) =>
	`${baseUrl}/get-department-level-course-advisers?${generateUrlParams(
		filter
	)}`;

export const assignLevelCourseAdvisersUrl = () =>
	`${baseUrl}/assign-level-course-adviser`;
export const assignDepartmentProgramme = () =>
	`${baseUrl}/assign-department-programme`;
export const bulkDepartmentsUploadUrl = () => `${baseUrl}/upload-departments`;
export const bulkOptionsUploadUrl = () => `${baseUrl}/upload-options`;
export const createDepartmentUrl = () => `${baseUrl}/create-department`;
export const createOptionUrl = () => `${baseUrl}/create-option`;
export const deleteDepartmentUrl = (id) =>
	`${baseUrl}/delete-department?departmentId=${id}`;
export const deleteOptionUrl = (id) =>
	`${baseUrl}/delete-department-option?optionId=${id}`;
export const downloadDepartmentExcelTemplateUrl = () =>
	`${baseUrl}/download-department-upload-template`;
export const downloadOptionExcelTemplateUrl = () =>
	`${baseUrl}/download-department-upload-template`;
export const getAllAvailableDepartmentsUrl = () =>
	`${baseUrl}/all-available-departments`;
export const getAllDepartmentsUrl = (facultyId) =>
	`${baseUrl}/all-departments${facultyId ? `?facultyId=${facultyId}` : ""}`;
export const getAllPaginatedDepartmentsUrl = (filter) =>
	`${baseUrl}/get-paginated-departments?${generateUrlParams(filter)}`;
export const getAllPaginatedOptionsUrl = (filter) =>
	`${baseUrl}/get-paginated-departments-options?${generateUrlParams(filter)}`;
export const getDepartmentsAreaOfSpecializationUrl = (filter) =>
	`${baseUrl}/get-departments-programmes-area-of-specialization?${generateUrlParams(
		filter
	)}`;
export const getProgrammeDepartmentsUrl = (programId) =>
	`${baseUrl}/get-programme-departments?programId=${programId}`;
export const toggleDepartmentActivationStatusUrl = (id) =>
	`${baseUrl}/toggle-department-activation?departmentId=${id}`;
export const toggleOptionActivationStatusUrl = (id) =>
	`${baseUrl}/toggle-option-activation?optionId=${id}`;
export const updateDepartmentUrl = () => `${baseUrl}/update-department`;
export const updateOptionUrl = () => `${baseUrl}/update-department-option`;
